const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const BoatReviewService = {
  async fetchBoatReviews(boatId) {
    try {
      const response = await fetch(`${API_BASE_URL}/boats/${boatId}/reviews/`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async createReview(reviewData) {
    try {
      const response = await fetch(`${API_BASE_URL}/reviews/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(reviewData),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to create review');
      }
      return await response.json();
    } catch (error) {
      throw error;
    }
  },

  async fetchAllReviews() {
    try {
      const response = await fetch(`${API_BASE_URL}/reviews/`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch (error) {
      throw error;
    }
  },
};

export default BoatReviewService; 